<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, Container, Modal, Text } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';

	export let exitConfirmationModalState = false;
	export let showExitConfirmationModal;
	export let showAddEditModal;
	export let type;

	const dispatch = createEventDispatcher();
</script>

<Modal
	on:close={() => {
		dispatch('close', {
			exitConfirmationModalState: true,
			showExitConfirmationModal: false,
		});
	}}
	showModal={showExitConfirmationModal}
	title={$format('label_exit_modal', {
		default: 'Exit Without Saving?',
	})}
	backdropClose={false}
>
	<Container slot="content" class="p-s" padding="0">
		<Text>
			{$format('text_exit_confirmation_modal', {
				default:
					'If you exit without saving {the_type}, any changes you have made will be lost.',
				values: { the_type: type },
			})}
		</Text>
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={() => {
				dispatch('close', {
					exitConfirmationModalState: true,
					showExitConfirmationModal: false,
				});
			}}
		>
			{$format('button_keep_editing', { default: 'Keep editing' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={() => {
				dispatch('confirm', {
					showExitConfirmationModal: false,
					showAddEditModal: false,
				});
			}}
		>
			{$format('button_exit_without_saving', {
				default: 'Exit without saving',
			})}
		</Button>
	</div>
</Modal>
